var OrderDetailsService = /** @class */ (function () {
    function OrderDetailsService($http, $log) {
        'ngInject';
        this.$http = $http;
        this.$log = $log;
    }
    OrderDetailsService.prototype.getOrderDetails = function (transactionNumber, createDate) {
        var self = this;
        return this.$http.get('api/account/orderDetails/' + transactionNumber + '/date/' + createDate)
            .then(function success(response) {
            return response.data.response;
        }, function error(response) {
            self.$log.error('error response.....', response);
        });
    };
    OrderDetailsService.prototype.getOrderDiscounts = function (orderId) {
        return this.$http({
            method: 'GET',
            url: 'api/account/GetPromotionsByOrder?fulfillmentId=' + orderId
        }).then(function (response) {
            return response.data.body;
        });
    };
    return OrderDetailsService;
}());
export { OrderDetailsService };
//# sourceMappingURL=order-details.service.js.map